export enum RunExpenseField {
    ITEM = 'item',
    AMOUNT = 'amount',
    COMMENT = 'comment',
}